import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';

const modeSlice = createSlice({
  name: 'modeType',
  initialState,
  reducers: {
    setModeType(state, { payload }) {
      state.type = payload;
    },
    resetState() { return initialState; },
  },
});

export const {
  setModeType,
  resetState,
} = modeSlice.actions;

export default modeSlice.reducer;
